import React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import SettingStyles from '../../SettingStyle.module.scss';
import { PATH as SETTING } from '~/pages/vendors/settings';
import { PATH as INDEX } from '~/pages/vendors/settings/surveys/index';
import { SurveyForm } from '~/components/specifics/vendors/settings/surveys/form/SurveyForm';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { useSurveySettings } from '~/hooks/vendors/useSurveySettings';

export const Page: React.FC = () => {
  const id = useIdQueryHandler();
  const { data: survey, mutate: mutateSurvey } = useSurveySettings().show(id);
  const handleMutateSurvey = React.useCallback(async () => {
    await mutateSurvey?.();
  }, [mutateSurvey]);
  if (survey === null || survey.activatedAt !== null) {
    return null;
  }
  return (
    <VendorLayoutV2>
      <VendorSettingLayout>
        <div className={SettingStyles.PcBreadcrumbsWrapper}>
          <Breadcrumbs
            items={[
              { label: 'アンケート設定', as: Link, href: INDEX },
              { label: '編集' }
            ]}
          />
        </div>
        <div className={SettingStyles.SpBreadcrumbsWrapper}>
          <Breadcrumbs
            items={[
              { label: '設定一覧', as: Link, href: SETTING },
              { label: 'アンケート設定', as: Link, href: INDEX },
              { label: '編集' }
            ]}
          />
        </div>
        <SurveyForm handleMutate={handleMutateSurvey} survey={survey} />
      </VendorSettingLayout>
    </VendorLayoutV2>
  );
};
